import envJson from "../env.json";

//Calculate Date of Birth
export function getAge(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

// Mobile Number validation
export function mobileNumberValid(MobileNumber) {
  var mob = /^[6-9]{1}[0-9]{9}$/;
  if (mob.test(MobileNumber) === false) {
    return false;
  }
  return true;
}

// Hide Mobile Number
export function hideMobileNumber(MobileNumber) {
  if (MobileNumber.length === 10) {
    return (
      MobileNumber.slice(0, 2) + MobileNumber.slice(2).replace(/.(?=...)/g, "*")
    );
  }
  return null;
}

// email address vaildation
// export function emailAddressValid(emailAddress) {
//   return emailAddress.match(
//     /^([A-Z?a-z0-9_\-.])+\@([A-Za-z_\-\.])+\.([A-Za-z]{2,4})$/
//   );
// }

export function emailAddressValid(emailAddress) {
  // Updated regex for a more accurate email validation
  return emailAddress.match(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  );
}


// otp vaildation
export function otpVerfiyValid(otp) {
  return /^\d{4}$/.test(otp);
}

// newPasswordValid vaildation
export function newPasswordValid(password, cpassword) {
  return password === cpassword;
}

export const clearUndefinedObject = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      delete obj[key];
    } else if (obj[key] === "undefined") {
      delete obj[key];
    }
  });
  return obj;
};

export function handleDetailResponse(result) {
  let data = "";
  if (Array.isArray(result)) {
    data = result[0];
  } else {
    data = result;
  }
  return data ? clearUndefinedObject(data) : {};
}

export function loginMustChangePassword(loginResponse) {
  return Boolean(
    handleDetailResponse(loginResponse?.data)?.must_change_password,
  );
}

export function handleListResponse(result) {
  let data;
  if (Array.isArray(result)) {
    data = result.map((item) => clearUndefinedObject(item));
  } else {
    data = [];
  }
  return data;
}

export function normalizeMongoId(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  if (typeof value === "string") {
    return value.trim();
  }

  if (typeof value === "object") {
    if (typeof value.$oid === "string") {
      return value.$oid;
    }
    if (value._id !== undefined) {
      return normalizeMongoId(value._id);
    }
    if (typeof value.toString === "function") {
      const asString = value.toString();
      if (/^[a-f\d]{24}$/i.test(asString)) {
        return asString;
      }
    }
  }

  return String(value).trim();
}

export function isValidMongoObjectId(value) {
  return /^[a-f\d]{24}$/i.test(normalizeMongoId(value));
}

// Aadhar validation
export function validateAadhaar(ano) {
  var regexp = /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/;
  if (regexp.test(ano)) {
    return true;
  } else {
    return false;
  }
}

// Pancard validation
export const pancardValidation = (text) => {
  let regex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
  if (regex.test(text)) {
    return true;
  }

  return false;
};

// name validation
export function nameValid(name) {
  return name.match(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/);
}

/** Strip non-alphabetic characters from visitor name input (parity with mobile). */
export function filterAlphabetsOnlyName(value) {
  return String(value ?? '').replace(/[^A-Za-z\s]/g, '');
}

export function visitorNameInputHasInvalidChars(value) {
  return filterAlphabetsOnlyName(value) !== String(value ?? '');
}

// Account_Number_validation
export function accountNumberValid(number) {
  return number.match("^[0-9]{9,18}$");
}

// Certificate_Number_validation
export function certificateNumber(number) {
  const regex = new RegExp(/^(UPRERA[A-Z]{3}\d{8,8}|[A-Z]\d{11,12})$/);
  return regex.test(number);
}

// IFSC_Number_validation
export function ifscValid(ifsc) {
  return ifsc.match("^[A-Z]{4}0[A-Z0-9]{6}$");
}

// GST_number_validation
export function gstNumberValid(gstNumber) {
  return gstNumber.match(
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
  );
}

export const x = (p, n) => ({ start: p * n + 1, end: p * n + n });
export const getRecordsText = (total, offset, itemsPerPage, length) => {
  const records = Number(total) || 0;
  const pageLength = Number(length) || 0;
  const perPage = Number(itemsPerPage) > 0 ? Number(itemsPerPage) : 10;
  const page = Math.max(0, Number(offset) || 0);

  if (!records || !pageLength) {
    return `Showing 0 to 0 out of ${records} entries`;
  }

  const start = page * perPage + 1;
  const end = Math.min(page * perPage + pageLength, records);
  return `Showing ${start} to ${end} out of ${records} entries`;
};

export function seo(data = {}) {
  data.title = data.title || "Default title";
  data.metaDescription = data.metaDescription || "Default description";
  data.canonicalLink = data.canonicalLink || "/";

  document.title = envJson?.ENV === "STAG"? "jUSTO ( ST ) | " + data.title : "jUSTO | " + data.title;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", data.metaDescription);
  document
    .querySelector('link[rel="canonical"]')
    .setAttribute("href", data.canonicalLink);
}

// remove am pm function
export const convertTime12to24 = (time12h) => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}`;
};

// Validation_Property_Image_Video
export const ValidateExtensionImgeVideo = (fileUpload) => {
  var allowedFiles = [
    ".jpg",
    ".jpeg",
    ".png",
    ".mp4",
    ".pdf",
    ".JPG",
    ".JPEG",
    ".PNG",
    ".MOV",
    ".MP4",
    ".PDF",
    ".HEIF",
    ".doc",
    ".DOC",
    ".docx",
  ];
  var regex = new RegExp(
    "([a-zA-Z0-9s_\\.-:])+(" + allowedFiles.join("|") + ")$"
  );
  if (!regex.test(fileUpload.value.toLowerCase())) {
    return "Allowed extension " + allowedFiles.join(", ");
  }
  return true;
};

// Validation_Image
// export const ValidateExtensionImge = (fileUpload) => {
//   var allowedFiles = [".jpg", ".jpeg", ".png", ".JPG", ".JPEG", ".PNG"];
//   var regex = new RegExp(
//     "([a-zA-Z0-9s_\\.-:])+(" + allowedFiles.join("|") + ")$"
//   );
//   if (!regex.test(fileUpload.value.toLowerCase())) {
//     return "Allowed extension " + allowedFiles.join(", ");
//   }
//   return true;
// };

export const ValidateExtensionImge = (file) => {
  var allowedFiles = [".jpg", ".jpeg", ".png", ".JPG", ".JPEG", ".PNG"];
  // Extract file extension
  const fileExtension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
  
  // Check if the file extension is in the allowed list
  if (!allowedFiles.includes("." + fileExtension)) {
    return "Allowed extension " + allowedFiles.join(", ");
  }
  return true;
};

// Validation_CSV
export const ValidateExtensionCsv = (fileUpload) => {
  var allowedFiles = [".csv", ".CSV"];
  var regex = new RegExp(
    "([a-zA-Z0-9s_\\.-:])+(" + allowedFiles.join("|") + ")$"
  );
  if (!regex.test(fileUpload.value.toLowerCase())) {
    return "Allowed extension " + allowedFiles.join(", ");
  }
  return true;
};

// Validation_Video
export const ValidateExtensionVideo = (fileUpload) => {
  var allowedFiles = [".mp4", ".MOV", ".MP4"];
  var regex = new RegExp(
    "([a-zA-Z0-9s_\\.-:])+(" + allowedFiles.join("|") + ")$"
  );
  if (!regex.test(fileUpload.value.toLowerCase())) {
    return "Allowed extension " + allowedFiles.join(", ");
  }
  return true;
};

//Minimum and maximum budget Error validation
export const minORmaxAmountValid = (
  min = "",
  max = "",
  min_type = "",
  max_type = ""
) => {
  if (min !== "" && max !== "" && min_type !== "" && max_type !== "") {
    if (
      (String(min_type) === "L" && String(max_type) === "L") ||
      (String(min_type) === "C" && String(max_type) === "C")
    ) {
      if (Number(min) > Number(max)) {
        return false;
      }
    } else if (!(String(min_type) === "L" && String(max_type) === "C")) {
      return false;
    } else if (String(min_type) === "C" && String(max_type) === "L") {
      return false;
    }
  }
  return true;
};
export const minORmaxValid = (min = "", max = "") => {
  if (min !== "" && max === "") {
    return 1;
  }
  if (min === "" && max !== "") {
    return 2;
  }
  return true;
};

//Minimum and maximum budget Error validation
export const minORmaxAmountEmiValid = (
  min = "",
  max = "",
  min_type = "",
  max_type = ""
) => {
  if (min !== "" && max !== "" && min_type !== "" && max_type !== "") {
    if (
      (String(min_type) === "L" && String(max_type) === "L") ||
      (String(min_type) === "C" && String(max_type) === "C") ||
      (String(min_type) === "K" && String(max_type) === "K")
    ) {
      if (Number(min) > Number(max)) {
        return false;
      }
    } else if (String(min_type) === "K") {
      if (!(String(max_type) === "L" || String(max_type) === "C")) {
        return false;
      }
    } else if (String(min_type) === "L") {
      if (!String(max_type) === "C") {
        return false;
      } else if (String(max_type) === "K") {
        return false;
      }
    } else if (String(min_type) === "C") {
      if (String(max_type) === "L") {
        return false;
      } else if (String(max_type) === "K") {
        return false;
      }
    }
  }
  return true;
};

export function convertToSlug(str) {
  //replace all special characters | symbols with a space
  str = str
    .replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ")
    .toLowerCase();

  // trim spaces at start and end of string
  str = str.replace(/^\s+|\s+$/gm, "");

  // replace space with dash/hyphen
  str = str.replace(/\s+/g, "_");
  return str;
}

// validate_object
export function isEmpty(value) {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0) ||
    (!(value instanceof Date) &&
      typeof value === "object" &&
      Object.keys(value).length === 0)
  );
}

//  image convert base64 data
export function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL.replace(/^data:image\/?[A-z]*;base64,/);
}

//  convert video thumbnail
export const generateVideoThumbnail = (file) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const video = document.createElement("video");

    // this is important
    video.autoplay = true;
    video.muted = true;
    video.src = URL.createObjectURL(file);

    video.onloadeddata = () => {
      let ctx = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      video.pause();
      return resolve(canvas.toDataURL("image/png"));
    };
  });
};

// Download_CSV_File
export function downloadURI(uri, name) {
  var link = document.createElement("a");
  // If you don't know the name or want to use
  // the webserver default set name = ''
  link.setAttribute("download", name);
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

// Check_valid_JSON_stringfy_object
export function isJSON(str) {
  if (/^\s*$/.test(str)) return false;
  str = str.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@");
  str = str.replace(
    /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
    "]"
  );
  str = str.replace(/(?:^|:|,)(?:\s*\[)+/g, "");
  return /^[\],:{}\s]*$/.test(str);
}

// Check_valid_JSON_stringfy_object
export function isValidAadhar(str) {
  return str
    .replace(/\D/g, "")
    .split(/(?:([\d]{4}))/g)
    .filter((s) => s.length > 0)
    .join(" ");
}

// program to get the file extension
// export function getFileExtension(filename) {
//   // get file extension
//   const extension = filename.split(".").pop();
//   return extension;
// }
export function getFileExtension(filename) {
  // Ensure the filename is a string before using split
  if (typeof filename === 'string' && filename.includes('.')) {
    // Get the file extension by splitting the string at the dot
    const extension = filename.split('.').pop().toLowerCase();
    return extension;
  } else {
    // If the filename is not a valid string or doesn't have a dot, return null or an empty string
    return null;
  }
}

export function getCPLeadType(cp_lead_type) {
  if (cp_lead_type == 1) {
    return " (Direct)";
  } else if (cp_lead_type == 2) {
    return " (Tele-calling)";
  } else return "";
}

function normalizeFloorValue(floor) {
  if (floor == null || floor === "") {
    return "";
  }

  if (typeof floor === "number") {
    if (Number.isNaN(floor)) {
      return "";
    }
    return String(floor);
  }

  if (typeof floor === "boolean") {
    return "";
  }

  if (typeof floor === "string") {
    return floor.trim();
  }

  if (typeof floor === "object") {
    const nested =
      floor.value ?? floor.label ?? floor.name ?? floor.en_US ?? floor.en;
    if (nested != null && typeof nested !== "object") {
      return normalizeFloorValue(nested);
    }
  }

  return "";
}

/** True for any selectable floor, including `"0"` / `0`. */
export function hasFloorValue(floor) {
  return normalizeFloorValue(floor) !== "";
}

export { normalizeFloorValue };

function getFloorSortRank(floor) {
  const label = normalizeFloorValue(floor);
  if (!label) {
    return { rank: Number.POSITIVE_INFINITY, label: "" };
  }

  const lower = label.toLowerCase();

  if (lower.includes("basement") || /^b-?\d*$/.test(lower)) {
    const basementLevel = parseInt(lower.replace(/\D/g, ""), 10);
    return {
      rank: -1000 - (Number.isNaN(basementLevel) ? 0 : basementLevel),
      label,
    };
  }

  if (
    lower === "g" ||
    lower === "ground" ||
    lower.includes("ground floor") ||
    lower === "gf"
  ) {
    return { rank: 0, label };
  }

  if (lower === "lg" || lower.includes("lower ground")) {
    return { rank: 0.5, label };
  }

  if (lower === "ug" || lower.includes("upper ground")) {
    return { rank: 1, label };
  }

  if (/^-?\d+(\.\d+)?$/.test(label)) {
    return { rank: Number(label), label };
  }

  const numericMatch = label.match(/-?\d+/);
  if (numericMatch) {
    return { rank: Number(numericMatch[0]), label };
  }

  return { rank: 10000, label };
}

export function sortFloors(floors) {
  const seen = new Set();
  const uniqueFloors = [];

  for (const floor of floors || []) {
    const key = normalizeFloorValue(floor);
    if (!key || seen.has(key)) {
      continue;
    }

    seen.add(key);
    uniqueFloors.push(key);
  }

  return uniqueFloors.sort((a, b) => {
      const left = getFloorSortRank(a);
      const right = getFloorSortRank(b);
      if (left.rank !== right.rank) {
        return left.rank - right.rank;
      }
      return left.label.localeCompare(right.label, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
}

export function getUniqueSortedFloorsFromInventory(inventory) {
  if (!Array.isArray(inventory)) {
    return [];
  }
  return sortFloors(inventory.map((item) => item?.Floor));
}

//
